/* Glossmere: when 2 heads are chosen, let the buyer pick a finish for the second head. Saved as the line item property "Second head finish". */
(function () {
  function init(root) {
    if (root.__gmf2) return;
    var fin = root.querySelector('.swatches[aria-label="Finish"]');
    var heads = root.querySelector('[aria-label="Heads"]');
    var form = root.querySelector('form[data-gm-form]');
    if (!fin || !heads || !form) return;
    root.__gmf2 = true;
    var finInputs = Array.prototype.slice.call(fin.querySelectorAll('input[data-gm-opt]'));
    if (!finInputs.length) return;
    var uid = 'gm-fin2-' + Math.random().toString(36).slice(2, 8);

    var wrap = document.createElement('div');
    wrap.className = 'gm-fin2';
    wrap.hidden = true;
    var lab = document.createElement('div');
    lab.className = 'opt-label';
    lab.innerHTML = '<span style="margin-left:0">Second head finish</span>';
    var group = document.createElement('div');
    group.className = 'swatches';
    group.setAttribute('role', 'radiogroup');
    group.setAttribute('aria-label', 'Second head finish');
    finInputs.forEach(function (inp) {
      var src = inp.closest('label');
      var l = document.createElement('label');
      l.className = 'sw';
      var r = document.createElement('input');
      r.type = 'radio'; r.name = uid; r.value = inp.value;
      l.appendChild(r);
      var dot = src && src.querySelector('i');
      if (dot) l.appendChild(dot.cloneNode(true));
      l.appendChild(document.createTextNode(inp.value));
      group.appendChild(l);
    });
    var hidden = document.createElement('input');
    hidden.type = 'hidden'; hidden.name = 'properties[Second head finish]'; hidden.value = '';
    wrap.appendChild(lab); wrap.appendChild(group); wrap.appendChild(hidden);
    // place right after the first finish swatches
    fin.parentNode.insertBefore(wrap, fin.nextSibling);
    var radios = Array.prototype.slice.call(group.querySelectorAll('input'));
    var touched = false;

    function headCount() {
      var c = heads.querySelector('input:checked');
      return c ? (parseInt(c.value, 10) || 1) : 1;
    }
    function firstFinish() {
      var c = fin.querySelector('input:checked');
      return c ? c.value : '';
    }
    function sync() {
      var n = headCount();
      wrap.hidden = n < 2;
      if (n < 2) { hidden.value = ''; touched = false; return; }
      if (!touched) {
        var f = firstFinish();
        radios.forEach(function (r) { r.checked = (r.value === f); });
      }
      var sel = radios.filter(function (r) { return r.checked; })[0];
      hidden.value = sel ? sel.value : firstFinish();
      radios.forEach(function (r) { r.closest('label').classList.toggle('on', r.checked); });
    }
    root.addEventListener('change', function (e) {
      if (e.target.name === uid) touched = true;
      setTimeout(sync, 0);
    });
    sync();
    window.addEventListener('load', function () { setTimeout(sync, 80); });
  }
  function boot() { document.querySelectorAll('[data-gm-product]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', function () { setTimeout(boot, 60); });
  document.addEventListener('shopify:section:load', function () { setTimeout(boot, 60); });
})();
